module.exports = __webpack_public_path__ + "img/closeeye.cdbf60b2.svg";